import React, { useRef, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import CheckoutReturnHandler from '../components/CheckoutReturnHandler';
import ExpandedAccessUpgradeModal from '../components/modals/ExpandedAccessUpgradeModal';

export default function DashboardLayout({ children }) {
	const mainRef = useRef(null);
	const location = useLocation();

	// Reset scroll container on route change to avoid stale inline styles
	// left by page-level scripts/modals/tours.
	useEffect(() => {
		const el = mainRef.current;
		if (!el) return;
		el.style.removeProperty('overflow');
		el.style.removeProperty('overflow-y');
		el.style.removeProperty('height');
		el.style.overflowY = 'auto';
		el.scrollTo(0, 0);
	}, [location.pathname]);

	return (
		<div id="main_dashboard" className="flex flex-col min-h-screen h-screen overflow-hidden">
			<CheckoutReturnHandler />
			<ExpandedAccessUpgradeModal />
			<Navbar />

			<div className="flex flex-1 min-h-0">
				<Sidebar />
				<main
					key={location.pathname}
					ref={mainRef}
					className="flex-1 min-h-0 min-w-0 bg-bgColor md:px-[50px] p-6 overflow-y-auto overflow-x-hidden"
				>
					{/* For simple wrap usage */}
					{children}

					{/* For nested route usage */}
					<Outlet />
				</main>
			</div>
		</div>
	);
}
